/* import __COLOCATED_TEMPLATE__ from './edit-sidebar-button.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();